import { QueryKeys } from "@/constants/Query";
import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";
import { useQueryClient } from "@tanstack/react-query";

interface CreateCuraiAdminNoteParams {
  noteText: string;
}

interface CreateCuraiAdminNoteResponse {
  noteText: string;
}

export const useCreateCuraiAdminNote = ({
  encounterId,
  motherEncounterId,
  patientId,
}: {
  encounterId?: string;
  patientId?: string;
  motherEncounterId?: string;
}) => {
  const queryClient = useQueryClient();

  return useApiMutation<
    CreateCuraiAdminNoteResponse,
    CreateCuraiAdminNoteParams
  >({
    mutationOptions: {
      mutationKey: QueryKeys.Patient.MedicalRecords.Timeline.ENCOUNTER({
        patientId,
        motherEncounterId,
        encounterId,
      }),
      mutationFn: (params) => {
        return axiosInstance.post(
          `/clinic/visits/${encounterId}/admin-note`,
          params,
        );
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: QueryKeys.Patient.MedicalRecords.Timeline.ENCOUNTER({
            patientId,
            motherEncounterId,
            encounterId,
          }),
        });
        queryClient.invalidateQueries({
          queryKey: QueryKeys.Patient.MedicalRecords.Timeline.ENCOUNTERS({
            patientId,
          }),
        });
      },
    },
  });
};
